/**
 * React Query Hooks for Users API
 */

import { useQuery } from '@tanstack/react-query';
import { usersApi } from '../../api/users';
import { queryKeys } from '../../lib/queryClient';

/**
 * Fetch direct reports for a manager
 */
export function useDirectReports(userId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.users.directReports(userId!),
    queryFn: () => usersApi.getDirectReports(userId!),
    enabled: !!userId,
  });
}
